import { render, staticRenderFns } from "./QyKanbanTV.vue?vue&type=template&id=7760980e&"
import script from "./QyKanbanTV.vue?vue&type=script&lang=js&"
export * from "./QyKanbanTV.vue?vue&type=script&lang=js&"
import style0 from "./QyKanbanTV.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports